import { NavTabData } from './types';
import { composeUrlWithSearchParams, performRedirect } from './redirect-helpers';
import ssoRedirects from './sso-redirects';
import Config from '../config-manager';
import { systemError, longTermToken } from '../events-manager';
import { pushState } from '../url-utils';

/**
 * Initiates a redirect to the path or url associated with the navigation tab id.
 * @param id
 */
export const initiateRedirectFromNavTab = (id: number) => {
  const tabs = Config.get<NavTabData[]>('tabs', []);
  const tab = tabs.find(tab => tab.id === id);

  if (!tab || !tab.path) {
    systemError.publishCriticalError({ error: 'Could not find redirect path' });
    return;
  }
  if (tab.ninespokes) {
    ssoRedirects.initiate9SpokesRedirect(tab.path);
  } else {
    pushState(tab.path);
  }
};

/**
 * Redirects the user to the 9Spokes Dashboard.
 */
export const redirectTo9SpokesDashboard = () => {
  const tabs = Config.get<NavTabData[]>('tabs', []);
  const path = tabs?.find(tab => tab.title === 'Track')?.path;
  if (!path) {
    systemError.publishCriticalError({ error: 'Could not find MTrack dashboard path from config' });
    return;
  }
  ssoRedirects.initiate9SpokesRedirect(path);
};

/**
 * Redirects the user to the Marketplace Landing page.
 */
export const redirectToMarketplaceLandingPage = () => {
  const tabs = Config.get<NavTabData[]>('tabs', []);
  const path = tabs?.find(tab => tab.title === 'Marketplace')?.path;
  if (!path) {
    systemError.publishCriticalError({ error: 'Could not find Marketplace landing page path from config' });
    return;
  }
  pushState(path);
};

/**
 * Redirects the user to the BiB login page.
 */
export const redirectToBiBLoginPage = () => {
  const loginUrl = Config.get<string>('login_and_registration.url');
  const loginUrlParams = Config.get<Record<string, string>>('login_and_registration.params');
  if (!loginUrl || !loginUrlParams) {
    systemError.publishCriticalError({ error: 'Could not get login redirect url or params from config' });
    return;
  }
  const loginUrlWithParams = composeUrlWithSearchParams(loginUrl, loginUrlParams);
  performRedirect(loginUrlWithParams);
};

/**
 * Redirects the user to the BiB home page.
 */
export const redirectToBiB = () => {
  if (longTermToken.isTokenValid() === false) {
    redirectToBiBLoginPage();
    return;
  }
  const bibUrl = Config.get<string>('bib_redirect_url');
  if (!bibUrl) {
    systemError.publishCriticalError({ error: 'Could not get bib redirect url from config' });
    return;
  }
  const accessToken = longTermToken.getToken();
  // set token to NOT to be deleted
  longTermToken.setTokenDelete(false);

  const bibUrlParams = {
    user_type: 'business',
  };
  const bibUrlWithParams = composeUrlWithSearchParams(bibUrl, bibUrlParams) + '#' + Config.get<string>('bib_redirect_url_search_params.token') + '=' + accessToken;
  performRedirect(bibUrlWithParams);
};
